class ImageHotspotsSelector {
    constructor($el) {
        this.$el = $el;

        this.isOpened = false;

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$pois = this.$el.find('.image-hotspots-selector__poi');

        if(this.$pois.length) {
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.toggleFn = this._toggle.bind(this);

        this.$pois.each((index, el) => {
            $(el).on('click', this.toggleFn);
        });
    }

    _toggle(e) {
        const $target = $(e.currentTarget);

        if($target) {
            var $alreadyOpenedPois = this.$pois.not($target).filter('.image-hotspots-selector__poi--opened');
            if($alreadyOpenedPois.length) {
                $alreadyOpenedPois.removeClass('image-hotspots-selector__poi--opened');
            }
            
            $target.toggleClass('image-hotspots-selector__poi--opened');
            this.isOpened = !this.isOpened;
        }
    }
}

export default ImageHotspotsSelector;
